import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import NavTab from "../components/NavTab";
import { Container } from "../layout/Container";
import axios from "axios";
import LiveCard from "../components/cards/Live";
import ReplayCard from "../components/cards/Replay";
import { getPublicReplays } from "../services/replaysApi";
import { ENV_CONFIG } from "../config/environment-unified";

export default function Game() {
  const { id } = useParams();
  const [game, setGame] = useState({});
  useEffect(() => {
    axios.get(`${ENV_CONFIG.GAME_ENDPOINT}${id}`).then((res) => {
      setGame({
        title: res.data.name,
        description: res.data.description,
        poster: res.data.landscapeImage,
        banner: res.data.portraitImage,
      });
    }).catch((error) => {
      console.error("Error loading game:", error);
    });
  }, [id]);
  const [index, setIndex] = useState(1);
  const list = ["Live Channels", "Videos"];

  return (
    <div>
      <Header game={game} />
      <Container style={{ paddingBottom: "3rem" }}>
        <NavTab list={list} index={index} setIndex={setIndex} />
        {index === 1 && <LiveChannels />}
        {index === 2 && <Replays />}
        {/* {index === 3 && <Tournaments />} */}
      </Container>
    </div>
  );
}

const Header = ({ game }) => {
  return (
    <HeaderStyle>
      <GradianL />
      {game.banner && <img id="coverimg" src={game.banner} alt={game.title} />}
      <GameDetails>
        <GamePoster>{game.poster && <img src={game.poster} alt={game.title} />}</GamePoster>
        <Gamedata>
          <GameTitle>{game.title}</GameTitle>
          <GameDescription>{game.description}</GameDescription>
        </Gamedata>
      </GameDetails>
    </HeaderStyle>
  );
};

const LiveChannels = () => {
  const [lives, setLives] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${ENV_CONFIG.STREAMS_ENDPOINT}?game=${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        setLives(res.data);
      })
      .catch((err) => {
        console.error("Error loading live channels:", err);
      });
  }, [id]);
  if (!lives || lives.length === 0) return "";
  return (
    <section style={{ display: "flex", flexWrap: "wrap" }}>
      {lives.map((live, index) => (
        <LiveCard
          thumbnail={live?.thumbnail}
          tags={live?.tags}
          avatar={live?.avatar}
          verified={live?.verified}
          username={live?.username}
          gif={live?.thumbnailGif}
          title={live?.title}
          gameName={live?.stream_games?.name || live?.game?.name}
          gameId={live?.stream_games?.id || live?.game?._id}
          key={index}
          style={{ marginRight: "10px" }}
        />
      ))}
    </section>
  );
  // return !lives?.length || !lives ? <></> : <CardsContainer full cardsselection={lives} />;
};

const Replays = () => {
  const [replays, setReplays] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getPublicReplays(1, 12, id)
      .then((response) => {
        setReplays(response.replays || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching replays for game:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div style={{ padding: "20px", color: "#666" }}>Loading replays...</div>;
  }

  if (!replays || replays.length === 0) {
    return <div style={{ padding: "20px", color: "#666" }}>No replays available for this game</div>;
  }

  return (
    <section style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {replays.map((replay) => (
        <ReplayCard
          key={replay.id}
          replay={replay}
        />
      ))}
    </section>
  );
};

// const Videos = () => {
//   const [videos, setVideos] = useState([]);
//   const { id } = useParams();

//   useEffect(() => {
//     axios
//       .get(process.env.REACT_APP_STREAMS_ENDPOINT + "?game=" + id, {
//         withCredentials: true,
//       })
//       .then((res) => {
//         setVideos(res.data);
//         console.log(res.data);
//       })
//       .catch((err) => {
//         console.log(err.response);
//       });
//   }, [id]);
//   console.log(videos);
//   return (!videos || !videos?.length) ? <></> : <CardsContainer full cardsselection={videos} />;
// };
// const Tournaments = () => {
//   const [tournaments, setTournaments] = useState([]);
//   const { id } = useParams();

//   useEffect(() => {
//     axios
//       .get(process.env.REACT_APP_TOURNAMENTS_ENDPOINT + "?game=" + id, {
//         withCredentials: true,
//       })
//       .then((res) => {
//         setTournaments(res.data);
//         console.log(res.data);
//       })
//       .catch((err) => {
//         console.log(err.response);
//       });
//   }, [id]);
//   return (!tournaments || !tournaments?.length) ? <></> : <CardsContainer full cardsselection={tournaments} />;
// };

const HeaderStyle = styled.div`
  width: 100%;
  min-height: 185px;
  height: 185px;
  max-height: 185px;
  border-radius: 0 0 10px 10px;
  background-color: ${({ theme }) => theme.color.background};
  border-radius: 0px 0px 10px 10px;
  margin-bottom: 185px;
  position: relative;
  #coverimg {
    border-radius: 0px 0px 10px 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
  @media (max-width: 576px) {
    margin-bottom: 232px;
    border-radius: 0px 0px 5px 5px;
  }
`;
const GameDetails = styled(Container)`
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 40%;
  height: auto;
  width: auto;
  min-width: 100%;
  z-index: 3;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
    height: auto;
    align-items: center;
    top: 40%;
    left: 50%;
    transform: translate(-50%, 0%);
  }
`;
const GamePoster = styled.div`
  width: 149px;
  height: 208px;
  min-width: 149px;
  min-height: 208px;
  object-fit: cover;
  border-radius: 11px;
  overflow: hidden;
  margin-right: 33px;
  background-color: ${({ theme }) => theme.color.background};
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 576px) {
    margin-right: 0px;
  }
`;
const Gamedata = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 576px) {
    align-items: center;
    font-size: 20px;
    color: ${({ theme }) => theme.color.darkerText};
  }
`;
const GameTitle = styled.div`
  font-family: "Poppins Bold";
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 120%;
  margin-top: 40px;

  margin-bottom: 20px;
  color: #ffffff;
  @media (max-width: 768px) {
    margin-top: 55px;
    font-size: 30px;
    line-height: 100%;
  }
  @media (max-width: 576px) {
    margin-top: 10px;
    margin-bottom: 0px;
    font-size: 20px;
    color: ${({ theme }) => theme.color.darkerText};
  }
`;
const GameDescription = styled.p`
  max-width: 673px;
  font-size: 16px;
  line-height: 150%;
  margin-top: 24px;
  color: ${({ theme }) => theme.color.darkerText};
  max-height: 100px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;

  @media (max-width: 576px) {
    margin-top: 0;
    margin-top: 10px;
    font-size: 14px;
  }
`;
const GradianL = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
  z-index: 1;
  border-radius: 0px 0px 10px 10px;
  @media (max-width: 576px) {
    margin-bottom: 232px;
    border-radius: 0px 0px 5px 5px;
  }
`;
